<app-section-wrapper-container [title]="'vehicles|record|next-operation|title'">
	@if (operation()?.subject === appSubjectEnum.RENTAL_AGREEMENT) {
		<app-rental-agreement-link-card [id]="operation().subjectId" />
	} @else if (operation()?.subject === appSubjectEnum.VEHICLE_MAINTENANCE) {
		<app-vehicle-maintenance-link-card [id]="operation().subjectId" />
	} @else {
		<div
			class="w-full h-40 rounded-3xl bg-neutral-50 dark:bg-neutral-900 flex items-center justify-center">
			@if (isLoading()) {
				<app-loading-spinner />
			} @else {
				<p class="subtle-text text-sm">
					{{ 'vehicles|record|next-operation|empty' | transloco }}
				</p>
			}
		</div>
	}
</app-section-wrapper-container>
